import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-refresh access token on 401 and retry the original request once.
// Prevents users losing in-progress work to silent JWT expiry.
let refreshInFlight = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const status = error.response?.status;
    const url = cfg?.url || '';
    if (
      status !== 401 ||
      !cfg ||
      cfg._retry ||
      url.includes('/auth/refresh') ||
      url.includes('/auth/login') ||
      url.includes('/auth/register')
    ) {
      return Promise.reject(error);
    }
    cfg._retry = true;
    try {
      refreshInFlight = refreshInFlight || api.post('/auth/refresh');
      await refreshInFlight;
      refreshInFlight = null;
      return api(cfg);
    } catch (e) {
      refreshInFlight = null;
      return Promise.reject(error);
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default api;
